module.exports = __webpack_public_path__ + "img/1.4a0759e9.jpg";